<template lang="html">

  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/catalogs')" style="cursor: pointer">Catálogos</li>
        <li class="breadcrumb-item active" aria-current="page">Encuesta de Grupos de Familia Preguntas-Respuestas</li>
      </ol>
    </nav>

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <md-card>
            <md-card-header>
              <div class="md-title">Preguntas
                <md-button class="md-icon-button md-raised md-primary" style="background-color: green; float: right" v-on:click="editQuestion='New'">
                  <md-icon>add</md-icon>
                </md-button>
              </div>
            </md-card-header>
            <md-card-content>
              <md-table>
                <md-table-row>
                  <md-table-head>ID</md-table-head>
                  <md-table-head>Grupo de Familia</md-table-head>
                  <md-table-head>Tipo de Encuesta</md-table-head>
                  <md-table-head>Pregunta</md-table-head>
                  <md-table-head>Tipo de Dato</md-table-head>
                  <md-table-head>Orden</md-table-head>
                  <md-table-head>Activo</md-table-head>
                  <md-table-head style="text-align: center">Editar | Borrar | Ver Respuestas</md-table-head>
                </md-table-row>
                <md-table-row v-if="editQuestion==='New'">
                  <md-table-cell>{{editQuestion}}</md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>Grupo de Familia</label>
                      <md-select v-model="family_group_id">
                        <md-option :value="fg.id" v-for="fg in family_groups" :key="fg.id">{{fg.name}}</md-option>
                      </md-select>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>Tipo de Encuesta</label>
                      <md-select v-model="survey_type">
                        <md-option :value="stype" v-for="stype in survey_types" :key="stype">{{stype}}</md-option>
                      </md-select>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>Pregunta</label>
                      <md-textarea v-model="question" md-autogrow/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>Tipo de Dato</label>
                      <md-select v-model="data_type">
                        <md-option :value="dtype" v-for="dtype in data_types" :key="dtype">{{dtype}}</md-option>
                      </md-select>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>Orden</label>
                      <md-input v-model="order" type="number"/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell style="text-align: center">
                    <label class="container">
                      <input type="checkbox" class="form-control" v-model="is_active"/>
                      <span class="checkmark" />
                    </label>
                  </md-table-cell>
                  <md-table-cell style="width: 16%;text-align: center">
                    <md-button class="md-icon-button md-mini md-raised" v-on:click="guardarQuestion()">
                      <md-icon>save</md-icon>
                    </md-button>
                    <md-button class="md-icon-button md-mini md-raised md-accent" v-on:click="limpiar()">
                      <md-icon>clear</md-icon>
                    </md-button>
                  </md-table-cell>
                </md-table-row>
                <md-table-row v-for="fg_survey_question in fg_survey_questions" :key="fg_survey_question.id">
                  <md-table-cell>{{fg_survey_question.id}}</md-table-cell>

                  <md-table-cell v-if="editQuestion===fg_survey_question.id">
                    <md-field>
                      <label>Grupo de Familia</label>
                      <md-select v-model="family_group_id">
                        <md-option :value="fg.id" v-for="fg in family_groups" :key="fg.id">{{fg.name}}</md-option>
                      </md-select>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>{{fg_survey_question.family_group}}</md-table-cell>

                  <md-table-cell v-if="editQuestion===fg_survey_question.id">
                    <md-field>
                      <label>Tipo de Encuesta</label>
                      <md-select v-model="survey_type">
                        <md-option :value="stype" v-for="stype in survey_types" :key="stype">{{stype}}</md-option>
                      </md-select>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>{{fg_survey_question.survey_type}}</md-table-cell>

                  <md-table-cell v-if="editQuestion===fg_survey_question.id">
                    <md-field>
                      <label>Pregunta</label>
                      <md-textarea v-model="question" md-autogrow/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>{{fg_survey_question.question}}</md-table-cell>

                  <md-table-cell v-if="editQuestion===fg_survey_question.id">
                    <md-field>
                      <label>Tipo de Dato</label>
                      <md-select v-model="data_type">
                        <md-option :value="dtype" v-for="dtype in data_types" :key="dtype">{{dtype}}</md-option>
                      </md-select>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>{{fg_survey_question.data_type}}</md-table-cell>

                  <md-table-cell v-if="editQuestion===fg_survey_question.id">
                    <md-field>
                      <label>Orden</label>
                      <md-input v-model="order" type="number"/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>{{fg_survey_question.order}}</md-table-cell>

                  <md-table-cell style="text-align: center" v-if="editQuestion===fg_survey_question.id">
                    <label class="container">
                      <input type="checkbox" class="form-control" v-model="is_active"/>
                      <span class="checkmark" />
                    </label>
                  </md-table-cell>
                  <md-table-cell v-else style="text-align: center">
                    <label class="container">
                      <input type="checkbox" class="form-control" v-model="fg_survey_question.is_active" disabled/>
                      <span class="checkmark" />
                    </label>
                  </md-table-cell>

                  <md-table-cell style="width: 20%;text-align: center" v-if="editQuestion===fg_survey_question.id">
                    <md-button class="md-icon-button md-mini md-raised" v-on:click="guardarQuestion()">
                      <md-icon>save</md-icon>
                    </md-button>
                    <md-button class="md-icon-button md-mini md-raised md-accent" v-on:click="limpiar()">
                      <md-icon>clear</md-icon>
                    </md-button>
                  </md-table-cell>
                  <md-table-cell v-else style="width: 20%;text-align: center">
                    <md-button class="md-icon-button md-mini md-raised md-primary" v-on:click="editarQuestion(fg_survey_question)">
                      <md-icon>edit</md-icon>
                    </md-button>
                    <md-button class="md-icon-button md-mini md-raised md-accent" v-on:click="borrarQuestion(fg_survey_question.id)">
                      <md-icon>delete</md-icon>
                    </md-button>
                    <md-button class="md-icon-button md-mini md-raised" v-on:click="verResponses(fg_survey_question)">
                      <md-icon>visibility</md-icon>
                    </md-button>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>

    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Pregunta: {{selectedQuestion}} (ID: {{selectedQuestionID}})</md-dialog-title>
      <md-card style="overflow-y: auto;">
        <md-card-header>
          <div class="md-title">Campos
            <md-button class="md-icon-button md-raised md-primary" style="background-color: green; float: right" v-on:click="editQuestionResponse='New'">
              <md-icon>add</md-icon>
            </md-button>
          </div>
        </md-card-header>
        <md-card-content class="md-scrollbar">
          <md-table>
            <md-table-row>
              <md-table-head>ID</md-table-head>
              <md-table-head>Pregunta</md-table-head>
              <md-table-head>Respuesta</md-table-head>
              <md-table-head>Pregunta Extra</md-table-head>
              <md-table-head>Orden</md-table-head>
              <md-table-head>Valor</md-table-head>
              <md-table-head>Editar | Borrar</md-table-head>
            </md-table-row>
            <md-table-row v-if="editQuestionResponse==='New'">
              <md-table-cell>{{editQuestionResponse}}</md-table-cell>
              <md-table-cell>{{selectedQuestionID}}. {{selectedQuestion}}</md-table-cell>
              <md-table-cell>
                <md-field>
                  <label>Respuesta</label>
                  <md-textarea v-model="response" md-autogrow/>
                </md-field>
              </md-table-cell>
              <md-table-cell>
                <md-field>
                  <label>Pregunta Extra</label>
                  <md-select v-model="extra_question_id">
                    <md-option :value="extra.id" v-for="extra in extra_questions" :key="extra.id">{{extra.id}}. {{extra.question}}</md-option>
                  </md-select>
                </md-field>
              </md-table-cell>
              <md-table-cell>
                <md-field>
                  <label>Orden</label>
                  <md-input v-model="response_order" type="number"/>
                </md-field>
              </md-table-cell>
              <md-table-cell>
                <md-field>
                  <label>Valor</label>
                  <md-input v-model="valor" type="number"/>
                </md-field>
              </md-table-cell>
              <md-table-cell style="width: 16%;text-align: center">
                <md-button class="md-icon-button md-mini md-raised" v-on:click="guardarResponse()">
                  <md-icon>save</md-icon>
                </md-button>
                <md-button class="md-icon-button md-mini md-raised md-accent" v-on:click="limpiarResponse()">
                  <md-icon>clear</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
            <md-table-row v-for="fg_survey_response in fg_survey_responses" :key="fg_survey_response.id">
              <md-table-cell>{{fg_survey_response.id}}</md-table-cell>
              <md-table-cell>{{fg_survey_response.fg_survey_question_id}}. {{selectedQuestion}}</md-table-cell>

              <md-table-cell v-if="editQuestionResponse===fg_survey_response.id">
                <md-field>
                  <label>Response</label>
                  <md-textarea v-model="response" md-autogrow/>
                </md-field>
              </md-table-cell>
              <md-table-cell v-else>{{fg_survey_response.response}}</md-table-cell>

              <md-table-cell v-if="editQuestionResponse===fg_survey_response.id">
                <md-field>
                  <label>Pregunta Extra</label>
                  <md-select v-model="extra_question_id">
                    <md-option :value="extra.id" v-for="extra in extra_questions" :key="extra.id">{{extra.id}}. {{extra.question}}</md-option>
                  </md-select>
                </md-field>
              </md-table-cell>
              <md-table-cell v-else>{{fg_survey_response.extra_question}}</md-table-cell>

              <md-table-cell v-if="editQuestionResponse===fg_survey_response.id">
                <md-field>
                  <label>Orden</label>
                  <md-input v-model="response_order" type="number"/>
                </md-field>
              </md-table-cell>
              <md-table-cell v-else>{{fg_survey_response.order}}</md-table-cell>

              <md-table-cell v-if="editQuestionResponse===fg_survey_response.id">
                <md-field>
                  <label>Valor</label>
                  <md-input v-model="valor" type="number"/>
                </md-field>
              </md-table-cell>
              <md-table-cell v-else>{{fg_survey_response.value}}</md-table-cell>

              <md-table-cell style="width: 20%;text-align: center" v-if="editQuestionResponse===fg_survey_response.id">
                <md-button class="md-icon-button md-mini md-raised" v-on:click="guardarResponse()">
                  <md-icon>save</md-icon>
                </md-button>
                <md-button class="md-icon-button md-mini md-raised md-accent" v-on:click="limpiarResponse()">
                  <md-icon>clear</md-icon>
                </md-button>
              </md-table-cell>
              <md-table-cell v-else style="width: 20%;text-align: center">
                <md-button class="md-icon-button md-mini md-raised md-primary" v-on:click="editarResponse(fg_survey_response)">
                  <md-icon>edit</md-icon>
                </md-button>
                <md-button class="md-icon-button md-mini md-raised md-accent" v-on:click="borrarResponse(fg_survey_response.id)">
                  <md-icon>delete</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
      <md-dialog-actions>
        <md-button class="md-primary" @click="cerrarDialog()">Cerrar</md-button>
      </md-dialog-actions>
    </md-dialog>

  </div>


</template>

<script lang="js">
  export default  {
    name: 'fg-survey',
    props: [],
    mounted() {
      this.getQuestions();
      axios.get( '/api/catalogs/family_groups').then(response => {
        this.family_groups = response.data.data;
      });
    },
    data() {
      return {
        editQuestion: null,
        fg_survey_questions: [],
        family_groups: [],
        survey_types: [
          'supplier_interview', 'testimony'
        ],
        data_types: [
          'combo', 'text', 'date', 'number', 'textarea'
        ],
        family_group_id: null,
        survey_type: null,
        question: null,
        data_type: null,
        order: 0,
        is_active: null,
        showDialog: false,

        fg_survey_responses:[],
        extra_questions: [],
        selectedQuestion: '',
        selectedQuestionID: null,
        editQuestionResponse: null,
        response: null,
        extra_question_id: null,
        response_order: 0,
        valor: 0,
      }
    },
    methods: {
      limpiar(){
        this.editQuestion = null;
        this.family_group_id = null;
        this.survey_type = null;
        this.question = null;
        this.data_type = null;
        this.order = null;
        this.is_active = null;
      },
      getQuestions(){
        axios.get( '/api/catalogs/fg_survey_questions').then(response => {
          this.fg_survey_questions = response.data.data;
        });
      },
      guardarQuestion(){
        Vue.toasted.show('Guardando Pregunta...', { position: 'bottom-center', closeOnSwipe: false });
        axios.post( '/api/catalogs/fg_survey_questions/save', {
          'fg_survey_question_id': this.editQuestion === 'New' ? -1 : this.editQuestion,
          'family_group_id': this.family_group_id,
          'survey_type': this.survey_type,
          'question': this.question,
          'data_type': this.data_type,
          'order': this.order,
          'is_active': this.is_active
        }).then(response => {
          this.limpiar();
          this.getQuestions();
          Vue.toasted.clear();
          Vue.toasted.show('¡¡ Pregunta guardada correctamente !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      },
      editarQuestion(question){
        this.editQuestion = question.id;
        this.family_group_id = question.family_group_id;
        this.survey_type = question.survey_type;
        this.question = question.question;
        this.data_type = question.data_type;
        this.order = question.order;
        this.is_active = question.is_active;
      },
      borrarQuestion(fgsqid){
        Vue.toasted.show('Borrando Pregunta...', { position: 'bottom-center', closeOnSwipe: false });
        axios.post( '/api/catalogs/fg_survey_questions/delete', {
          'fg_survey_question_id': fgsqid,
        }).then(response => {
          this.getQuestions();
          Vue.toasted.clear();
          Vue.toasted.show('¡¡ Pregunta borrada correctamente !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      },
      verResponses(question){
        axios.get( '/api/catalogs/fg_survey_responses/'+question.id+'/get').then(response => {
          this.showDialog = true;
          this.selectedQuestion = question.question;
          this.selectedQuestionID = question.id;
          this.fg_survey_responses = response.data.data;
          this.extra_questions = response.data.extra_questions;
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      },
      limpiarResponse(){
        this.editQuestionResponse = null;
        this.response = null;
        this.extra_question_id = null;
        this.response_order = null;
        this.valor = null;
      },
      guardarResponse(){
        Vue.toasted.show('Guardando Respuesta...', { position: 'bottom-center', closeOnSwipe: false });
        axios.post( '/api/catalogs/fg_survey_responses/save', {
          'fg_survey_response_id': this.editQuestionResponse === 'New' ? -1 : this.editQuestionResponse,
          'fg_survey_question_id': this.selectedQuestionID,
          'response': this.response,
          'extra_question_id': this.extra_question_id,
          'order': this.response_order,
          'value': this.valor
        }).then(response => {
          this.limpiarResponse();
          axios.get( '/api/catalogs/fg_survey_responses/'+this.selectedQuestionID+'/get').then(response => {
            this.fg_survey_responses = response.data.data;
            this.extra_questions = response.data.extra_questions;
          }).catch(error => {
            Vue.toasted.clear();
            Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
          });
          Vue.toasted.clear();
          Vue.toasted.show('¡¡ Respuesta guardada correctamente !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      },
      editarResponse(response){
        this.editQuestionResponse = response.id;
        this.response = response.response;
        this.extra_question_id = response.extra_question_id;
        this.response_order = response.order;
        this.valor = response.value;
      },
      borrarResponse(fgsrid){
        Vue.toasted.show('Borrando Respuesta...', { position: 'bottom-center', closeOnSwipe: false });
        axios.post( '/api/catalogs/fg_survey_responses/delete', {
          'fg_survey_response_id': fgsrid,
        }).then(response => {
          axios.get( '/api/catalogs/fg_survey_responses/'+this.selectedQuestionID+'/get').then(response => {
            this.fg_survey_responses = response.data.data;
            this.extra_questions = response.data.extra_questions;
          }).catch(error => {
            Vue.toasted.clear();
            Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
          });
          Vue.toasted.clear();
          Vue.toasted.show('¡¡ Respuesta borrada correctamente !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      },
      cerrarDialog(){
        this.showDialog = false;
        this.selectedQuestion = "";
        this.selectedQuestionID = null;
        this.fg_survey_responses = [];
        this.extra_questions = [];
      },
    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .src-views-admin-catalogs-fg-survey {

  }
</style>

<style scoped>
  /* Customize the label (the container) */
  .container {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 35px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Hide the browser's default checkbox */
  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #eee;
    margin-left: 30%;
    border-radius: 30px;
  }

  /* On mouse-over, add a grey background color */
  .container:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a blue background */
  .container input:checked ~ .checkmark {
    background-color: rgb(243, 205, 33);
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .container input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .container .checkmark:after {
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
</style>